// extracted by mini-css-extract-plugin
export const container = "styles-module--container--38eLz";
export const captionImg = "styles-module--caption-img--MAYIB";